/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { OfficeStatus } from '@gh/builder-shared-data';
import { rendererIconByName, ROW_DELETED_CLASS, ROW_IN_DELETION_CLASS, truthyCellRenderer } from '@gh/common-internal-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';

import { SubOfficeListItem } from '../../resources/sub-office-list-item.model';

const STATUSES = {
  'ACTIVE': 'Active',
  'BLOCKED': 'Blocked',
  'DEACTIVATED': 'Deactivated',
  'IN_DELETION': 'In',
};

@Injectable()
export class SubOfficeListGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    status: {
      valueGetter: (params: any) => STATUSES[params.node.data.subOfficeStatus],
      cellClass: ({ data }: { data: any }) => (
        {
          'ACTIVE': 'active-status',
          'BLOCKED': 'blocked-status',
          'DEACTIVATED': 'deactivated-status',
          'IN_DELETION': 'inDeletion-status',
        }
        [data.subOfficeStatus || '']
      ),
    },
    isPublicListed: {
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
    },
  };

  options = {
    getRowClass: ({ data }: { data: SubOfficeListItem }) => {
      if (data.subOfficeStatus === OfficeStatus.Deactivated) {
        return ROW_DELETED_CLASS;
      }
      if (data.statusValue === OfficeStatus.InDeletion) {
        return ROW_IN_DELETION_CLASS;
      }
    },
    getRowNodeId: (data: SubOfficeListItem) => data.subOfficeId,
  };

  constructor() {
    super();
  }
}
